/*
 * <cart-upsell> — fetches Shopify product recommendations for a seed product
 * (the cart's most-expensive item, rendered into data-product-id), injects the
 * compact card list returned by the dm-cart-upsell section, and adds variants
 * to the cart in place via the cart drawer's renderContents refresh.
 *
 * Falls back from intent=complementary to intent=related when complementary
 * returns nothing (new stores have little complementary data).
 */
class CartUpsell extends HTMLElement {
  connectedCallback() {
    const seed = this.dataset.productId;
    if (!seed) {
      this.hidden = true;
      return;
    }
    this.addEventListener('click', this.onClick.bind(this));
    this.loadRecommendations(seed, this.dataset.intent || 'complementary', false);
  }

  loadRecommendations(productId, intent, isFallback) {
    const url = `${this.dataset.url}&intent=${intent}&product_id=${productId}&section_id=${this.dataset.sectionId}`;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const parsed = document.createElement('div');
        parsed.innerHTML = text;
        const list = parsed.querySelector('.dm-cart-upsell__list');

        if (list && list.children.length) {
          this.render(list);
        } else if (intent === 'complementary' && !isFallback) {
          this.loadRecommendations(productId, 'related', true);
        } else {
          this.hidden = true;
        }
      })
      .catch((e) => {
        console.error(e);
        this.hidden = true;
      });
  }

  render(list) {
    this.innerHTML = '';
    const heading = this.dataset.heading;
    if (heading) {
      const h = document.createElement('p');
      h.className = 'dm-cart-upsell__heading';
      h.textContent = heading;
      this.appendChild(h);
    }
    this.appendChild(list);
    this.hidden = false;
  }

  onClick(event) {
    const button = event.target.closest('.dm-cart-upsell__add[data-variant-id]');
    if (!button) return;
    event.preventDefault();
    this.addVariant(button);
  }

  addVariant(button) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    const body = { id: button.dataset.variantId, quantity: 1 };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: response });
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else if (!cart) {
          // Cart page (no drawer/notification present) — reload so the newly
          // added item appears in the cart.
          window.location.reload();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }
}

customElements.define('cart-upsell', CartUpsell);
